import './App.css';
import MemoryGame from './MemoryGame.jsx'

function App() {
  return (
    <div className="App">
      <MemoryGame/>
    </div>
  );
}

export default App;
